module.exports = __webpack_public_path__ + "img/card.3f3caf34.svg";